import { Component, effect, DestroyRef, inject, OnInit, signal, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ContractRestService} from '../../core/api/contract-rest.service';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule, PageEvent } from '@angular/material/paginator';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatCardModule } from '@angular/material/card';
import { PageRequest, PageResponse, Template } from '../../core/models/template.model';
import { from } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Router } from '@angular/router';

@Component({
  selector: 'app-contract-list',
  imports: [CommonModule,
    MatTableModule,
    MatPaginatorModule,
    MatProgressSpinnerModule,
    MatButtonModule,
    MatIconModule,
    MatCardModule,
    MatTooltipModule
  ],
  templateUrl: './contract-list.component.html',
  styleUrl: './contract-list.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: true
})
export class ContractListComponent {
  private destroyRef = inject(DestroyRef);
  contractRestService: ContractRestService = inject(ContractRestService);
  pageRequest = signal<PageRequest>({
    page: 0,
    size: 10,
    sort: ['createdAt,desc']
  });
  loading = signal<boolean>(false);
  error: any = signal<Error | undefined>(undefined);
  private router = inject(Router);

  displayedColumns: string[] = ['status', 'name', 'description', 'createdAt', 'updatedAt', 'actions'];

  constructor() {
    effect(() => {
      this.loadContracts(this.pageRequest());
    });
  }
  contracts: any= signal<PageResponse<Template> | undefined>(undefined);

  async loadContracts(pageRequest: any, search?: string, company?: string) {
    try {
      from(this.contractRestService.getContracts(this.pageRequest(), search, company))
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (response: any) => {
          console.log(response);
          this.contracts.set(response);
        }
      });
    } catch (err) {
      this.error.set(err as Error);
    } finally {
      this.loading.set(false);
    }
  }

  async onPageChange(event: PageEvent): Promise<void> {
    this.pageRequest.set({
      page: event.pageIndex,
      size: event.pageSize,
      sort: this.pageRequest().sort
    });

    await this.loadContracts(this.pageRequest());
  }

  editContract(id: number) {

  }

  deleteContract(id: number) {

  }

  refresh() {
    this.loadContracts(this.pageRequest());
  }

  navigateToNewContract() {
    this.router.navigate(['/neuer-vertrag']);
  }
}
